import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/footer/footer';
import Navigation from '../components/navigation/navigation';
var Layout = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(Navigation, null),
        React.createElement(Outlet, null),
        React.createElement(Footer, null)));
};
export default Layout;
